module.exports = __webpack_public_path__ + "img/hot.ed9db1a.svg";